exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-12b157c7]{display:block;margin:0;padding:5px}ul li[data-v-12b157c7]{list-style:none;cursor:pointer;padding:5px}li[data-v-12b157c7]:hover{background:rgba(83,215,220,.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-12b157c7","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/VContext/VContext.vue
// module id = 17
// module chunks = 0